const host_websocket = process.env.VUE_APP_HOST_WEBSOCKET

export const host_url_static = process.env.VUE_APP_HOST_URL

// 新增项目
export const api_project_create = '/admin/project/create'

// 项目列表
export const api_project_list = '/admin/project/list'

// 项目详细信息
export const api_project_baseInfo = '/admin/project/info'

// 删除项目接口
export const api_project_del = '/admin/project/delete'

// 编辑项目接口
export const api_project_edit = '/admin/project/update'

// 项目回收站
export const api_project_recycle = '/admin/project/recycle/list'

// 项目回收站恢复
export const api_project_restore = '/admin/project/restore'

// 项目成员列表
export const api_project_memberList = '/admin/project/member/list'

// json数据保存
export const api_graph_save = '/admin/graph/json/upsert'

// 数据统一保存
export const api_graph_save_all = '/admin/graph/save'

// 获取图的json数据
export const api_graph_info = '/admin/graph/json/info'

// 图的节点信息更新
export const api_graph_node_add = '/admin/graph/node/upsert'

// 图的节点数据 - 获取
export const api_graph_node_info = '/admin/graph/node/info'

// 图的关系数据 - 获取
export const api_graph_edge_info = '/admin/graph/relation/info'

// 图的关系信息 - 更新
export const api_graph_edge_add = '/admin/graph/relation/upsert'

// 画图 - 节点 - 删除
export const api_graph_node_delete = '/admin/graph/node/delete'

// 画图 - 关系 - 删除
export const api_graph_relation_delete = '/admin/graph/relation/delete'

// 图谱作品列表
export const admin_graph_works = '/admin/graph/work/list'

// 新增作品
export const admin_graph_works_add = '/admin/graph/work/create'

// 重命名作品名称
export const admin_graph_works_rename = '/admin/graph/work/rename'

// 作品删除
export const admin_graph_works_delete = '/admin/graph/work/delete'

// 获取作品json数据
export const admin_graph_info = '/admin/graph/work/json/info'

// 保存作品json数据
export const admin_graph_works_save = '/admin/graph/work/json/upsert'

// 查询直接关联节点
export const admin_graph_works_searchB = '/admin/graph/work/searchB'

// 搜索关联节点数据
export const admin_graph_node_search = '/admin/graph/node/search'

// 查询直接关联的多节点(多路径)
export const admin_graph_path_search = '/admin/graph/work/searchAB'

// 修改作品状态
export const admin_graph_works_upStatus = '/admin/graph/work/status'

// 作品复制
export const admin_graph_works_copy = '/admin/graph/work/copy'

// 批量上传
export const admin_graph_import = '/admin/graph/import'

// 公开数据
export const api_graph_pub = '/admin/graph/open/upsert'

// 更新json数据公开状态
export const api_graph_pub_works = '/admin/graph/work/open/upsert'

// 图谱数据和作品公开总阀门
export const admin_project_open_upsert = '/admin/project/open/upsert'

// 获取作品公开状态
export const api_project_baseInfoOpen = '/admin/graph/work/open/status'

// 获取上传url
export const admin_getSign = '/admin/obs/public/puturl'

// 排序作品
export const admin_graph_works_sort = '/admin/graph/work/order'

// 批量排序作品
export const admin_graph_works_sort_more = '/admin/graph/work/orderNums'

// 获取项目简介
export const admin_graph_works_intro = '/admin/project/update/desc'

// 更新类型数据
export const admin_graph_update_types = '/admin/project/update/types'

// 即时通信
export const socket_get_url = host_websocket + '/admin/ws/project/status/getting'

// 维持项目编辑状态
export const socket_set_url = host_websocket + '/admin/ws/project/status/setting'

// 维持作品编辑状态
export const socket_set_work_url = host_websocket + '/admin/ws/project/work/status/setting'

// 维持本体模型编辑状态
export const socket_set_onto_url = host_websocket + '/admin/ws/project/ontology/status/setting'

// 监听消息系统
export const socket_message_url = host_websocket + '/admin/ws/notify'

// 消息中心--列表
export const admin_notify_list = '/admin/user/notify/list'

// 消息中心--已读
export const admin_notify_readed = '/admin/user/notify/readed'

// 消息中心--未读消息列表
export const admin_notify_unreaded_list = '/admin/user/notify/unread'
// 站点--列表
export const admin_site_list = '/open/project/share/list'

// 原始数据--公开
export const admin_site_public = '/admin/project/share/data/open'

// 站点--更新
export const admin_site_update = '/admin/project/open/sites'

// 原始数据--更新
export const admin_site_public_update = '/admin/project/share/data/update'

// 原始数据--取消公开
export const admin_site_public_cancel = '/admin/project/share/data/cancel'

// 作品数据--公开
export const admin_site_public_work = '/admin/project/share/work/open'

// 本体模型数据--公开
export const admin_onto_public_work = '/admin/project/share/ontology/open'

// 作品数据--更新
export const admin_site_public_work_update = '/admin/project/share/work/update'

// 作品数据--取消公开
export const admin_site_public_work_cancel = '/admin/project/share/work/cancel'

// 本体模型数据--取消公开
export const admin_onto_public_work_cancel = '/admin/project/share/ontology/cancel'

// 本体模型数据--更新
export const admin_onto_public_work_update = '/admin/project/share/ontology/update'

// 存档--新增
export const admin_archive_add = '/admin/project/archive/create'

// 存档--列表
export const admin_archive_list = '/admin/project/archive'

// 存档--恢复
export const admin_archive_recover = '/admin/project/archive/revert'

// 存档--删除
export const admin_archive_delete = '/admin/project/archive'

// 分享管理--获取已经创建的分享链接
export const admin_graph_works_share = '/admin/project/share/get'

// 分享管理--创建分享链接
export const admin_graph_works_share_create = '/admin/project/share/create'

// 分享管理--删除分享链接
export const admin_graph_works_share_cancel = '/admin/project/share/cancel'

// 分享管理--重置分享链接
export const admin_graph_works_share_reset = '/admin/project/share/reset'

// 本体模型json数据
export const api_graph_info_model = '/admin/project/ontology'

// 本体模型json数据保存
export const api_graph_save_model = '/admin/project/ontology'

// 自动保存json数据保存
export const api_graph_save_auto = '/admin/project/autosave'

// 自动保存json数据--作品
export const api_graph_save_auto_works = '/admin/project/work/autosave'

// 自动保存五日数据
export const api_graph_save_auto_recent = '/admin/project/autosave/recent'

// 自动保存五日数据--作品
export const api_graph_save_auto_recent_works = '/admin/project/work/autosave/recent'

// 自动保存历史版本列表
export const admin_graph_works_auto_save_list = '/admin/project/autosave/list'

// 自动保存历史版本恢复--作品
export const admin_graph_works_auto_works_save_list = '/admin/project/work/autosave/list'

// 获取图的预览json数据
export const api_graph_info_preview = '/admin/project/autosave/preview'

// 获取图的预览json数据的最近几天列表
export const api_graph_info_preview_days = '/admin/project/autosave/preview/recent'

// 自动保存 - 作品 - 预览
export const api_graph_info_preview_works = '/admin/project/work/autosave/preview'

// 自动保存 - 作品 - 预览 - 最近几天列表
export const api_graph_info_preview_days_works = '/admin/project/work/autosave/preview/recent'

// 获取本体模型自动保存列表
export const admin_graph_works_auto_works_save_list_ontologyModel = '/admin/project/ontology/autosave/list'

// 自动保存 - 本体模型 - 最近几次
export const api_graph_save_auto_onto = '/admin/project/ontology/autosave'

// 自动保存 - 本体模型 - 最近几日
export const api_graph_save_auto_recent_onto = '/admin/project/ontology/autosave/recent'

// 更新简介
export const admin_project_share_data_desc_update = '/admin/project/share/data/desc/update'

// 本体模型更新简介
export const admin_project_ontology_desc_update = '/admin/project/share/ontology/desc/update'

// 作品更新简介
export const admin_project_work_desc_update = '/admin/project/share/work/desc/update'


// 成员管理--相关接口
export const member = {
    // 成员退出
    exit: '/admin/project/member/exit',
    // 成员拒绝加入项目
    refuse: '/admin/project/member/refuse',
    // 同意加入项目
    agree: '/admin/project/member/agree',
    // 获取邀请链接
    invite: '/admin/project/member/invite',
    // 项目成员添加新成员
    adds: '/admin/project/member/adds',
    // 项目成员修改成员角色
    upRole: '/admin/project/member/upRole',
    // 项目成员删除新成员
    remove: '/admin/project/member/remove',
    // 项目成员搜索新成员
    search: '/admin/project/member/search',
}

// 个人信息--相关接口
export const personal = {
    // 个人信息--修改密码
    resetPwd: '/admin/user/personal/resetPwd',
    // 个人信息--更新
    edit: '/admin/user/personal/edit',
}

// 发送短信
export const sms = {
    // 发送短信
    register: '/admin/sms/register',
}

// 用户管理
export const user = {
    // 用户登陆
    login: '/admin/user/login',
    // 用户注册
    add: '/admin/user/add',
    // 用户列表接口
    list: '/admin/user/list',
    // 用户删除接口
    del: '/admin/user/delete',
    // 用户重制密码
    reset: '/admin/user/resetPwd',
    // 编辑用户接口
    edit: '/admin/user/edit',
    // 新用户注册
    register: '/admin/user/register',
    // iframe 登陆
    iframeLogin: '/admin/iframe/getToken',
}

// 项目管理
export const project = {
    // 根据json文件刷新后台数据
    refresh: '/admin/project/data/refresh',
}

// 多人协作管理
export const collaboration = {
    //多人协作-数据-编辑者-获取差异数据
    getDiff: '/admin/collab/data/diff',
    //多人协作-数据-编辑者-更新差异数据
    updateDiff: '/admin/collab/data/diff/upsert',
    //多人协作-数据-审核者-获取所有差异数据
    getAllDiff: '/admin/collab/data/diffs',
    //多人协作-数据-审核者-更新指定的差异数据
    updateAllDiff: '/admin/collab/data/diffs/update',
    //多人协作-数据-审核者-删除指定的差异数据
    deleteDiff: '/admin/collab/data/diffs/delete',
    // 多人协作-数据-审核者-删除所有的差异数据
    deleteAllDiff: '/admin/collab/data/diffs/delete/all',
    // 多人协作-更新项目协作状态
    upStatus: '/admin/project/collab',

    // 多人协作-作品-编辑者-获取差异数据
    getDiffWork:'/admin/collab/work/diff',
    // 多人协作-作品-编辑者-更新差异数据
    updateDiffWork:'/admin/collab/work/diff/upsert',
    // 多人协作-作品-审核者-获取所有差异数据
    getAllDiffWork:'/admin/collab/work/diffs',
    // 多人协作-作品-审核者-更新指定的差异数据
    updateAllDiffWork:'/admin/collab/work/diffs/update',
    // 多人协作-作品-审核者-删除指定的差异数据
    deleteDiffWork:'/admin/collab/work/diffs/delete',
    // 多人协作-作品-审核者-删除所有的差异数据
    deleteAllDiffWork:'/admin/collab/work/diffs/delete/all',

    // 多人协作-本体-编辑者-获取差异数据
    getDiffOntology:'/admin/collab/ontology/diff',
    // 多人协作-本体-编辑者-更新差异数据
    updateDiffOntology:'/admin/collab/ontology/diff/upsert',
    // 多人协作-本体-审核者-获取所有差异数据
    getAllDiffOntology:'/admin/collab/ontology/diffs',
    // 多人协作-本体-审核者-更新指定的差异数据
    updateAllDiffOntology:'/admin/collab/ontology/diffs/update',
    // 多人协作-本体-审核者-删除指定的差异数据
    deleteDiffOntology:'/admin/collab/ontology/diffs/delete',
    // 多人协作-本体-审核者-删除所有的差异数据
    deleteAllDiffOntology:'/admin/collab/ontology/diffs/delete/all'
}